import { Button, Card, Typography } from "antd";
import { useState } from "react";

import prenodeLogoBlack from "../../assets/prenode_logo_black.png";
import prenodeLogoWhite from "../../assets/prenode_logo_white.png";
import { useTheme } from "../../providers/theme/useTheme";
import { CONFIG } from "../../utils/config";

const { Title, Paragraph } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { theme } = useTheme();

  const handleLogin = () => {
    setLoading(true);
    window.location.href = CONFIG.LOGIN_URL;
  };

  const logoSrc = theme === "dark" ? prenodeLogoWhite : prenodeLogoBlack;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Card style={{ width: 300, textAlign: "center" }}>
        <img src={logoSrc} alt="Prenode Logo" style={{ width: 100 }} />
        <Title level={2}>Welcome </Title>
        <Paragraph>Please log in to continue.</Paragraph>
        <Button
          type="primary"
          onClick={handleLogin}
          style={{ width: "100%" }}
          loading={loading}
        >
          {loading ? null : "Login"}
        </Button>
      </Card>
    </div>
  );
};

export default Login;
